(function(){
  if (window.__lmpInit) { return; }
  window.__lmpInit = true;
  var busy = false;
  var self = false;

  function root(){ return document.getElementById('lmp'); }

  function sectionId(){
    var r = root();
    var w = r && r.closest ? r.closest('[id^="shopify-section-"]') : null;
    return w ? w.id.replace('shopify-section-', '') : 'lm-panier';
  }

  function open(){
    var r = root();
    if (!r) { return; }
    r.classList.add('is-open');
    document.body.classList.add('lmp-locked');
    var x = r.querySelector('.lmp__x');
    if (x) { x.focus(); }
  }
  function close(){
    var r = root();
    if (!r) { return; }
    r.classList.remove('is-open');
    document.body.classList.remove('lmp-locked');
  }

  function badge(count){
    var els = document.querySelectorAll('.lmh__badge');
    for (var i = 0; i < els.length; i++) { els[i].textContent = count; }
  }

  function refresh(){
    var id = sectionId();
    self = true;
    return fetch('/?sections=' + encodeURIComponent(id), { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html = data[id];
        if (!html) { throw new Error('section absente'); }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('lmp');
        var cur = root();
        if (!fresh || !cur) { throw new Error('noeud absent'); }
        var wasOpen = cur.classList.contains('is-open');
        cur.innerHTML = fresh.innerHTML;
        cur.setAttribute('data-lmp-count', fresh.getAttribute('data-lmp-count') || '0');
        badge(fresh.getAttribute('data-lmp-count') || '0');
        if (wasOpen) { cur.classList.add('is-open'); }
        self = false;
      })
      .catch(function(){ self = false; window.location.reload(); });
  }

  function change(line, qty){
    if (busy) { return; }
    busy = true;
    self = true;
    var r = root();
    if (r) { r.style.cursor = 'progress'; }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function(){ self = false; return refresh(); })
      .then(function(){ busy = false; if (root()) { root().style.cursor = ''; } })
      .catch(function(){ busy = false; self = false; window.location.reload(); });
  }

  // On observe les appels panier du theme plutot que les clics : marche quel que
  // soit le bouton d'ajout, y compris ceux pilotes en JS par Horizon.
  var nativeFetch = window.fetch;
  window.fetch = function(){
    var a = arguments[0];
    var url = '';
    try { url = typeof a === 'string' ? a : (a && a.url) || ''; } catch (e) { url = ''; }
    var isCart = url && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    // Un appelant peut demander de rafraichir le tiroir sans l'ouvrir.
    var silent = false;
    if (isCart) { silent = window.__lmNoDrawer === true; window.__lmNoDrawer = false; }
    var p = nativeFetch.apply(this, arguments);
    if (isCart && !self) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function(res){
        if (!res || res.ok === false) { return; }
        if (busy) { return; }
        setTimeout(function(){
          refresh().then(function(){ if (isAdd && !silent) { open(); } });
        }, 60);
      }).catch(function(){});
    }
    return p;
  };

  document.addEventListener('click', function(e){
    if (!e.target.closest) { return; }
    var closer = e.target.closest('[data-lmp-close]');
    if (closer && root() && root().contains(closer)) { e.preventDefault(); close(); return; }

    var q = e.target.closest('[data-lmp-qty]');
    if (q) {
      e.preventDefault();
      change(parseInt(q.getAttribute('data-lmp-qty'), 10), parseInt(q.getAttribute('data-lmp-to'), 10));
      return;
    }

    var a = e.target.closest('a[href]');
    if (a && !a.hasAttribute('data-lmp-skip')) {
      var href = (a.getAttribute('href') || '').split('?')[0];
      if (/(^|\/)cart\/?$/.test(href)) {
        if (root()) { e.preventDefault(); refresh().then(open); }
      }
    }
  }, false);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && root() && root().classList.contains('is-open')) { close(); }
  });
})();
